"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FactsFeaturesOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<rect x="11" y="6" width="19" height="2" rx="0.97"/><rect x="11" y="15" width="19" height="2" rx="0.97"/><rect x="11" y="24" width="19" height="2" rx="0.97"/><path d="M6.69,5.69,5.4,5.45,4.77,4.22c-.15-.29-.39-.29-.54,0L3.6,5.45l-1.29.24c-.32.06-.41.31-.19.54l.93,1L2.86,8.62c0,.33.16.47.45.32l1.19-.6,1.19.6c.29.15.49,0,.45-.32L6,7.24l.93-1C7.1,6,7,5.75,6.69,5.69Z"/><path d="M6.69,14.69,5.4,14.45l-.63-1.23c-.15-.29-.39-.29-.54,0L3.6,14.45l-1.29.24c-.32.06-.41.31-.19.54l.93,1-.19,1.38c0,.33.16.47.45.32l1.19-.6,1.19.6c.29.15.49,0,.45-.32L6,16.24l.93-1C7.1,15,7,14.75,6.69,14.69Z"/><path d="M6.69,23.69,5.4,23.45l-.63-1.23c-.15-.29-.39-.29-.54,0L3.6,23.45l-1.29.24c-.32.06-.41.31-.19.54l.93,1-.19,1.38c0,.33.16.47.45.32l1.19-.6,1.19.6c.29.15.49,0,.45-.32L6,25.24l.93-1C7.1,24,7,23.75,6.69,23.69Z"/>';
var FactsFeaturesOutlineSVG = function FactsFeaturesOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.FactsFeaturesOutlineSVG = FactsFeaturesOutlineSVG;
FactsFeaturesOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(FactsFeaturesOutlineSVG);
exports.default = _default;